var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _vm.tableData.length > 0
          ? _c(
              "div",
              { staticClass: "current-list" },
              [
                _c("div", { staticClass: "mt15 mb15 flex flex-between" }, [
                  _c(
                    "div",
                    [
                      !_vm.testAccess && _vm.dimensionMax > 0
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: _vm.dimensionMax <= 0,
                                size: "small",
                                type: "primary",
                              },
                              on: { click: _vm.addAssess },
                            },
                            [_vm._v("\n            添加考核维度\n          ")]
                          )
                        : _c("div", { staticClass: "title-16" }, [
                            _vm._v("绩效考核"),
                          ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "total-score" }, [
                    _c("p", [
                      _c("span", { staticClass: "total-score-name" }, [
                        _vm._v(_vm._s(_vm.$t("access.totalscore")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(_vm._s(_vm.assessInfo.max || _vm.max)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", { staticClass: "total-score-name" }, [
                        _vm._v("个人评分:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "color-default number" }, [
                        _vm._v(_vm._s(_vm.finishRatioSum())),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.testAccess
                      ? _c("p", [
                          _c("span", { staticClass: "total-score-name" }, [
                            _vm._v("当前总分:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "number color-default" }, [
                            _vm._v(_vm._s(_vm.total)),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-scrollbar",
                  [
                    _vm._l(_vm.tableData, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "current-table" },
                        [
                          _c("div", { staticClass: "current-table-title" }, [
                            _c(
                              "div",
                              { staticClass: "left" },
                              [
                                (!_vm.testAccess && !_vm.isShow) ||
                                _vm.processIndex == 1
                                  ? [
                                      _c("span", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: item.name,
                                              expression: "item.name",
                                            },
                                          ],
                                          staticClass: "current-title-input",
                                          style: { width: _vm.text(item.name) },
                                          attrs: {
                                            autofocus: true,
                                            type: "text",
                                          },
                                          domProps: { value: item.name },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                item,
                                                "name",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.assessInfo.types == 0
                                                  ? _vm.$t(
                                                      "access.dimensionweight"
                                                    )
                                                  : _vm.$t(
                                                      "access.dimensionscore"
                                                    )
                                              ) +
                                              "\n\n                  "
                                          ),
                                          _c("el-input-number", {
                                            attrs: {
                                              controls: false,
                                              max: item.weight,
                                              min: 0,
                                              precision: 0,
                                            },
                                            model: {
                                              value: item.ratio,
                                              callback: function ($$v) {
                                                _vm.$set(item, "ratio", $$v)
                                              },
                                              expression: "item.ratio",
                                            },
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.assessInfo.types == 0
                                                  ? "%"
                                                  : ""
                                              ) +
                                              "\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "pl10" }, [
                                        _vm._v("当前得分"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "color-default" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.currentSum(item, index))
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c("span", [_vm._v(_vm._s(item.name))]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.assessInfo.types == 0
                                                ? _vm.$t(
                                                    "access.dimensionweight"
                                                  )
                                                : _vm.$t(
                                                    "access.dimensionscore"
                                                  )
                                            ) +
                                            "\n                  " +
                                            _vm._s(item.ratio) +
                                            "\n                  " +
                                            _vm._s(
                                              _vm.assessInfo.types == 0
                                                ? "%"
                                                : ""
                                            ) +
                                            "\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "pl10" }, [
                                        _vm._v("当前得分"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "color-default" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.currentFinishSum(item))
                                          ),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            !_vm.testAccess
                              ? _c("div", { staticClass: "text-right right" }, [
                                  _c("i", {
                                    staticClass: "el-icon-delete",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteTargetList(index, item)
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: item.target,
                                "default-expand-all": "",
                                "row-key": "id",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("access.targetname"),
                                  prop: "name",
                                  width: "160",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          !_vm.testAccess &&
                                          !_vm.verifyAccess &&
                                          _vm.strType !== "check"
                                            ? _c("el-input", {
                                                staticStyle: { width: "200px" },
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "access.placeholder01"
                                                  ),
                                                  autosize: "",
                                                  type: "textarea",
                                                },
                                                model: {
                                                  value: scope.row.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.name",
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(_vm._s(scope.row.name)),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("access.targetexplain"),
                                  "min-width": "300",
                                  prop: "content",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          !_vm.testAccess &&
                                          !_vm.verifyAccess &&
                                          _vm.strType !== "check"
                                            ? _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.testAccess,
                                                  placeholder: _vm.$t(
                                                    "access.placeholder02"
                                                  ),
                                                  autosize: "",
                                                  type: "textarea",
                                                },
                                                model: {
                                                  value: scope.row.content,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "content",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.content",
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.content)
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "评分标准",
                                  "min-width": "300",
                                  prop: "info",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          !_vm.testAccess &&
                                          !_vm.verifyAccess &&
                                          _vm.strType !== "check"
                                            ? _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.testAccess,
                                                  autosize: "",
                                                  placeholder: "输入评分标准",
                                                  type: "textarea",
                                                },
                                                model: {
                                                  value: scope.row.info,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "info",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.info",
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(_vm._s(scope.row.info)),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "完成情况 (自评)",
                                  prop: "finish_info",
                                  width: "200",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.testAccess &&
                                          _vm.strType !== "check"
                                            ? _c("el-input", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "access.inputcompletion"
                                                  ),
                                                  autosize: "",
                                                  type: "textarea",
                                                },
                                                model: {
                                                  value: scope.row.finish_info,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "finish_info",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.finish_info",
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.finish_info)
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _vm.assessInfo.status > 1
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "上级评价",
                                      "min-width": "150",
                                      prop: "check_info",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              !_vm.testAccess &&
                                              _vm.strType !== "check"
                                                ? _c("el-input", {
                                                    attrs: {
                                                      autosize: "",
                                                      placeholder: "上级评价",
                                                      type: "textarea",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.check_info,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "check_info",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.check_info",
                                                    },
                                                  })
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.check_info
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label:
                                    _vm.assessInfo.types === 0
                                      ? "权重%"
                                      : "分数",
                                  "min-width": "60",
                                  prop: "ratio",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          !_vm.testAccess &&
                                          !_vm.verifyAccess &&
                                          _vm.processIndex === 1
                                            ? _c("el-input", {
                                                staticStyle: { width: "120px" },
                                                attrs: {
                                                  max: 1000,
                                                  min: 0,
                                                  precision: 0,
                                                  "controls-position": "right",
                                                  placeholder: "0",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleScore(
                                                      index
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.ratio,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "ratio",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.ratio",
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(_vm._s(scope.row.ratio)),
                                              ]),
                                          _vm._v(" "),
                                          _vm.assessInfo.types == 0
                                            ? _c("span", [_vm._v("%")])
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _vm.assessInfo.types === 0
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "完成度 (自评)",
                                      "min-width": "100",
                                      prop: "finish_ratio",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "current-task" },
                                                [
                                                  _vm.testAccess &&
                                                  _vm.strType !== "check"
                                                    ? _c("el-progress", {
                                                        attrs: {
                                                          percentage: Number(
                                                            scope.row
                                                              .finish_ratio
                                                          ),
                                                          "show-text": false,
                                                          "stroke-width": 3,
                                                          width: 18,
                                                          type: "circle",
                                                        },
                                                      })
                                                    : _c("el-progress", {
                                                        attrs: {
                                                          percentage: Number(
                                                            scope.row
                                                              .finish_ratio
                                                          ),
                                                          "show-text": false,
                                                          "stroke-width": 3,
                                                          width: 18,
                                                          type: "circle",
                                                        },
                                                      }),
                                                  _vm._v(" "),
                                                  _vm.testAccess &&
                                                  _vm.strType !== "check"
                                                    ? _c("el-input", {
                                                        attrs: {
                                                          min: 0,
                                                          type: "number",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.numberChange(
                                                              scope.row
                                                                .finish_ratio,
                                                              100,
                                                              index,
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .finish_ratio,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "finish_ratio",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.finish_ratio",
                                                        },
                                                      })
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "padding",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .finish_ratio
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                  _vm._v(" "),
                                                  _c("span", [_vm._v("%")]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _c("el-table-column", {
                                    attrs: {
                                      label: "自评分",
                                      "min-width": "60",
                                      prop: "finish_ratio",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm.testAccess &&
                                              _vm.strType !== "check"
                                                ? _c("el-input", {
                                                    attrs: {
                                                      min: 0,
                                                      type: "number",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.numberChange(
                                                          scope.row
                                                            .finish_ratio,
                                                          scope.row.ratio,
                                                          index,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.finish_ratio,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "finish_ratio",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.finish_ratio",
                                                    },
                                                  })
                                                : _c(
                                                    "span",
                                                    { staticClass: "padding" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.finish_ratio
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                              _vm._v(" "),
                              _vm.assessInfo.types === 0 &&
                              _vm.assessInfo.status > 1
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "上级评分",
                                      "min-width": "80",
                                      prop: "score",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex current-task",
                                                },
                                                [
                                                  !_vm.testAccess &&
                                                  _vm.strType !== "check"
                                                    ? _c("el-input", {
                                                        attrs: {
                                                          min: 0,
                                                          type: "number",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.scopeChange(
                                                              scope.row.score,
                                                              100,
                                                              index,
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.score,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "score",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.score",
                                                        },
                                                      })
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.score
                                                          )
                                                        ),
                                                      ]),
                                                  _vm._v(" "),
                                                  _c("span", [_vm._v("%")]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.assessInfo.types === 1 &&
                              _vm.assessInfo.status > 1
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "上级评分",
                                      "min-width": "80px",
                                      prop: "score",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              !_vm.testAccess &&
                                              _vm.strType !== "check"
                                                ? _c("el-input", {
                                                    attrs: {
                                                      min: 0,
                                                      type: "number",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.scopeChange(
                                                          scope.row.score,
                                                          scope.row.ratio,
                                                          index,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row.score,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "score",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.score",
                                                    },
                                                  })
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.row.score)
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.testAccess
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("public.operation"),
                                      fixed: "right",
                                      prop: "address",
                                      width: "70",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-button", {
                                                staticClass: "current-delete",
                                                attrs: {
                                                  icon: "el-icon-delete",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleDelete(
                                                      index,
                                                      scope.$index,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.testAccess
                            ? _c(
                                "div",
                                { staticClass: "current-bottom" },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { lg: 12 } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addTarget(index)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("access.addTarget02")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.selectTarget(index)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("access.addTarget01")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.verifyAccess
                      ? _c(
                          "div",
                          { staticClass: "comment-list" },
                          _vm._l(_vm.reply, function (item, index) {
                            return _c(
                              "el-row",
                              { key: index, staticClass: "mb15" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "comment-list-left",
                                    attrs: { lg: 2 },
                                  },
                                  [
                                    _c("img", {
                                      attrs: { src: item.user.avatar, alt: "" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { lg: 22 } },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "comment-list-name" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.user.name) +
                                            "\n                "
                                        ),
                                        item.types === -1
                                          ? _c("span", [_vm._v("(自评)")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.types === 0
                                          ? _c("span", [_vm._v("(上级评价)")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.types === 1
                                          ? _c("span", [_vm._v("(绩效审核)")])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          _vm.userInfo.id !==
                                            _vm.assessInfo.test_uid ||
                                          item.types === 1,
                                        placeholder: _vm.$t(
                                          "access.placeholder16"
                                        ),
                                        rows: 3,
                                        resize: "none",
                                        type: "textarea",
                                      },
                                      model: {
                                        value: item.content,
                                        callback: function ($$v) {
                                          _vm.$set(item, "content", $$v)
                                        },
                                        expression: "item.content",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "comment-list" },
                      [
                        _c(
                          "el-row",
                          { staticClass: "mb15" },
                          [
                            _c(
                              "el-col",
                              {
                                staticClass: "comment-list-left",
                                attrs: { lg: 2 },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.assessInfo.test.avatar,
                                    alt: "",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { lg: 22 } },
                              [
                                _c("p", { staticClass: "comment-list-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.assessInfo.test
                                        ? _vm.assessInfo.test.name
                                        : _vm.userInfo.name
                                    ) + " (自评)"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      !_vm.testAccess || _vm.strType == "check",
                                    placeholder: _vm.$t("access.placeholder16"),
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.assessInfo.self_reply,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.assessInfo,
                                        "self_reply",
                                        $$v
                                      )
                                    },
                                    expression: "assessInfo.self_reply",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.processIndex > 1
                          ? _c(
                              "el-row",
                              { staticClass: "mb15" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "comment-list-left",
                                    attrs: { lg: 2 },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.assessInfo.check
                                          ? _vm.assessInfo.check.avatar
                                          : _vm.userInfo.avatar,
                                        alt: "",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { lg: 22 } },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "comment-list-name" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.assessInfo.check
                                              ? _vm.assessInfo.check.name
                                              : _vm.userInfo.name
                                          ) + " (备注)"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          !_vm.checkAccess ||
                                          _vm.strType == "check",
                                        placeholder: _vm.$t(
                                          "access.placeholder16"
                                        ),
                                        type: "textarea",
                                      },
                                      model: {
                                        value: _vm.assessInfo.reply,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.assessInfo, "reply", $$v)
                                        },
                                        expression: "assessInfo.reply",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkAccess
                          ? _c(
                              "el-row",
                              { staticClass: "mb15" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "comment-list-left",
                                    attrs: { lg: 2 },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon iconfont iconyincang1",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { lg: 22 } },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "comment-list-name" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.userInfo.name) +
                                            " (仅自己可见)"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.strType == "check",
                                        placeholder: _vm.$t("access.tips12"),
                                        type: "textarea",
                                      },
                                      model: {
                                        value: _vm.assessInfo.hide_reply,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.assessInfo,
                                            "hide_reply",
                                            $$v
                                          )
                                        },
                                        expression: "assessInfo.hide_reply",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "current-footer text-center" }, [
                      _c(
                        "div",
                        [
                          _vm.processIndex == 3
                            ? _c(
                                "span",
                                [
                                  _vm.testAccess
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { size: "small" },
                                          on: { click: _vm.addFinance },
                                        },
                                        [_vm._v(_vm._s(_vm.message2))]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.verifyAccess,
                                              expression: "verifyAccess",
                                            },
                                          ],
                                          attrs: { size: "small" },
                                          on: { click: _vm.addFinance },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.message1) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkAccess
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.addTemplate },
                                },
                                [_vm._v(_vm._s(_vm.$t("access.settemplate")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentButton && _vm.testAccess
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    loading: _vm.loading,
                                    size: "small",
                                    type: "primary",
                                  },
                                  on: { click: _vm.addPreserve },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("access.saveandsubmit")) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: _vm.$t("access.adddimension"),
            visible: _vm.dialogVisible,
            width: "450px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "current-dialog mb15" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("access.dimensionname")) + "："),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { type: "text" },
                model: {
                  value: _vm.from.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.from, "name", $$v)
                  },
                  expression: "from.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.assessInfo.types === 0
            ? _c("div", { staticClass: "current-dialog" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("access.dimensionweight")) + "(%)："),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        controls: false,
                        max: _vm.dimensionMax,
                        min: 1,
                        precision: 0,
                      },
                      model: {
                        value: _vm.from.ratio,
                        callback: function ($$v) {
                          _vm.$set(_vm.from, "ratio", $$v)
                        },
                        expression: "from.ratio",
                      },
                    }),
                    _vm._v(" "),
                    _vm.assessInfo.types === 0
                      ? _c("span", { staticClass: "current-dialog-icon" }, [
                          _vm._v("%"),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.clickCancel } }, [
                _vm._v(_vm._s(_vm.$t("public.cancel"))),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addOk } },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("setTemplate", {
        ref: "setTemplate",
        attrs: {
          loading: _vm.templateLoading,
          "set-template": _vm.setTemplate,
        },
        on: { handleTemplate: _vm.handleTemplate },
      }),
      _vm._v(" "),
      _c("selectTarget", {
        ref: "selectTarget",
        attrs: { title: _vm.$t("access.targetibrary") },
        on: { dialogChangeDada: _vm.dialogChangeDada },
      }),
      _vm._v(" "),
      _c("dialogForm", {
        ref: "dialogForm",
        attrs: {
          "form-data": _vm.formBoxConfig,
          "roles-config": _vm.rolesConfig,
        },
        on: { isOk: _vm.isOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }